import axios from 'axios'
import { getAuthToken, saveAuthToken } from 'storage'
import { LOGIN } from 'constants/app-paths'

const request = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
})

request.defaults.timeout = 100000

request.interceptors.response.use(
  (response) => response,
  (error) => {
    // returns 401 should erase old token
    if (error?.response?.status === 401 && window.location.pathname !== LOGIN) {
      saveAuthToken('')
      window.location.href = LOGIN
    }

    return Promise.reject(error)
  },
)

request.interceptors.request.use(
  (config) => ({
    ...config,
    headers: {
      ...config.headers,
      Authorization: getAuthToken(),
    },
  }),
)

export default request
